import React from 'react';
import SpecialMessagePopup from './SpecialMessagePopup';
import ConfirmationModal from './ConfirmationModal';

interface GameModalsProps {
  specialMessage: string | null;
  onDismissSpecialMessage: () => void;
  showUndoModal: boolean;
  onConfirmUndo: () => void;
  onCancelUndo: () => void;
  showQuitModal: boolean;
  onConfirmQuit: () => void;
  onCancelQuit: () => void;
  specialMessageDuration?: number; // Optional duration for special messages
}

const GameModals: React.FC<GameModalsProps> = ({
  specialMessage,
  onDismissSpecialMessage,
  showUndoModal,
  onConfirmUndo,
  onCancelUndo,
  showQuitModal,
  onConfirmQuit,
  onCancelQuit,
  specialMessageDuration,
}) => {
  return (
    <>
      {specialMessage && (
        <SpecialMessagePopup 
          message={specialMessage} 
          onDismiss={onDismissSpecialMessage} 
          duration={specialMessageDuration}
        />
      )}

      <ConfirmationModal
        isOpen={showUndoModal}
        title="UNDO TURN"
        message="Are you sure you want to undo the last turn?"
        type="undo"
        onConfirm={onConfirmUndo}  
        onCancel={onCancelUndo}    
      />

      <ConfirmationModal
        isOpen={showQuitModal}
        title="QUIT GAME"
        message="Do you really want to quit?"
        type="quit"
        onConfirm={onConfirmQuit}  
        onCancel={onCancelQuit}    
      />
    </>
  );
};

export default GameModals;